<template>
    <div class="packagesDetail">
        <p class="brder-b title" v-if="!isDisable">补贴套餐明细</p>
        <p class="brder-b title" v-else>套餐明细查询</p>
        <div class="form-table" v-if="isDisable">
            <div class="product ">付款单号：{{query.storeExpenditureNumber}}</div>
            <div class="product ">套餐类型：{{query.packageType == 1 ? '套餐A' : '套餐B'}}</div>
            <div class="product ">付款金额：{{query.paymentAmount}}</div>
            <div class="product ">审核状态：{{query.auditStatusName}}</div>
            <div class="product  w100">所属门店：{{query.storeName}} </div>
        </div>
        <div class="form-main">
            <!-- <div class="top-nav" v-if="!isDisable">
                <div :class="active == item.val ? 'active' : ''" v-for="(item, index) in navList" :key="index" @click="handelTab(item)">{{ item.text }}</div>
            </div> -->
            <div class="main">
                <div v-if="active == 1">图片1</div>
                <div v-if="active == 2">图片2</div>
            </div>
        </div>
        <!-- <div v-if="!isDisable" class="form-btn" @click="handelSubmit">提交</div> -->
    </div>
</template>

<script>
import {  Form, Field, RadioGroup, Radio, Toast } from 'vant';
import { addStoreExpenditure } from '@/api/index';
export default {
    components:{
        [Form.name] : Form,
        [Field.name] : Field,
        [RadioGroup.name] : RadioGroup,
        [Radio.name] : Radio,
        [Toast.name] : Toast
    },
    data(){
        return {
            radio: '',
            active: 1,
            navList: [{
                text: '套餐A',
                val: 1
            },{
                text: '套餐B',
                val: 2
            }],
            isDisable: this.$route.query.isDisable == 1,
            query: {}

        }
    },
    mounted() {
        if(this.isDisable) {
            this.packageType = Number(this.$route.query.packageType)
            this.query = this.$route.query
        } else {
            this.packageType = Number(this.$route.query.packageType)
        }
    },
    methods:{
        handelTab(item) {
            this.active = item.val
        },
        handelSubmit() {
            const query = this.$route.query
            let data = {
                storeId: query.storeId,
                packageType: this.active,
                remarks: `订单号：${ query.orderNumber } || 客户姓名：${ query.customerName } || 客户电话：${ query.customerPhone } || 合伙人不可开发票`
            }
            Toast.loading({
                message: '加载中...',
                forbidClick: true,
            });
            addStoreExpenditure(data).then(res=> {
                if(res.status == 200) {
                    Toast.success({
                        message: '操作成功！',
                        forbidClick: true,
                    })
                    setTimeout(() => {
                        this.$router.go(-1)
                    },1000)
                } else {
                    Toast.fail( res.message || '操作失败！')
                    setTimeout(() => {
                         Toast.clear();
                    },1000)
                }
            }).catch(()=>{
                Toast.clear();
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .packagesDetail{
            .title{
                height: 62px;
                font-size:30px;
                color:$color-51;
                line-height:70px;
                margin: 0 20px;
                padding-left: 16px;
                &::before{
                    content: '';
                    width:4px;
                    height:20px;
                    display: inline-block;
                    margin-right: 17px;
                    background:$color-176;
                }
            }
        .form-main{
            padding: 20px;
            .main{
                margin: 30px 0;
            }
            
            .top-nav{
                width: 100%;
                border-radius: 20px;
                overflow: hidden;
                display: flex;
                div{
                    width: 100%;
                    height: 55px;
                    line-height: 55px;
                    text-align: center;
                    background: #f0f0f0;
                    color: #666;
                    font-size: 24px;
                    &.active{
                        background: cornflowerblue;
                        color: #fff;
                    }
                }
            }
        }
        .form-table{
            display: flex;
            flex-wrap: wrap;
            margin: 20px 20px 0 20px;
            border-top: solid 1px #f0f0f0;
            border-left: solid 1px #f0f0f0;
            .flex-main.flex-main.flex-main{
                justify-content: flex-start;
                align-items: flex-start;
                div:nth-child(1) {
                    width: 120px;
                }
                div:nth-child(2) {
                    width: 550px;
                }
            }
            &>div{
                width: 50%;
                padding: 15px 0;
                border-right: solid 1px #f0f0f0;
                border-bottom: solid 1px #f0f0f0;
                box-sizing: border-box;
                padding-left: 10px;
                &.w100{
                    width: 100%;
                }
            }
        }
        .form-btn{
            margin: 0 20px;
            border-radius: 10px;
            height: 60px;
            line-height: 60px;
            text-align: center;
            color: #fff;
            background: cornflowerblue;
        }
    }
</style>